<template>
    <el-button v-loading="isloading" type="primary" :size="size" @click="sendKingdee" :disabled="ids.length < 1">
        <i class="fa fa-eyedropper"></i>&nbsp;<slot></slot>
    </el-button>
</template>
<script>
    /**
     * 批量发送金蝶
     * @author zjs
     * @time 2018-06-29
     */
    export default {
        name: "LyButtonKingdee",
        props: {
            api: String, // 备注提交的地址
            rows: { // 要备注列的数据集合
                type: Array,
                default: () => []
            },            
            size: {
                type: String,
                default: 'small'
            }
        },
        data () {
            return {
                isloading: false
            }
        },
        computed: {
            ids () {
                let id = []
                this.rows.forEach((el) => {
                    if (el.id) {
                        id.push(el.id)
                    }
                })
                return id
            }
        },
        methods: {
            /**
             * 发送到金蝶
             */
            sendKingdee () {
                this.$alert('是否要批量发送金蝶？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    callback: action => {    
                        this.isloading = true                    
                        this.$api.save(this.api, {
                            ids: this.ids
                        }).then(() => {
                            this.isloading = false
                            this.$message({
                                type: 'success',
                                message: '批量发送金蝶完成'
                            })
                            this.$emit('sendKingdeeDone')
                        }).catch((msg) => {
                            this.isloading = false
                            this.$message({
                                type: 'warning',
                                message: msg
                            })
                        })
                    }
                })
            }
        }
    }
</script>